/*
 * @Author: your name
 * @Date: 2021-12-20 13:49:38
 * @LastEditTime: 2021-12-20 13:52:32
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\api\index.js
 */
import request from "../utils/request";

export function getBanner(query) {
  return request({
    url: "/manager/gw/getBanner",
    method: "get",
    params: query,
  });
}
// 医院列表
export function earePage(data) {
  return request({
    url: "/manager/eare/list",
    method: "post",
    data,
  });
}
